export type SceneConfig = {
  mlVersion: string;
};
